import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { getActiveAds, dismissAd, clickAd } from "../../services/ads.service";

function AdBanner() {
  const [ads, setAds] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!ads || ads.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % ads.length);
    }, 30000);

    return () => clearInterval(interval);
  }, [ads]);

  useEffect(() => {
    loadAds();
  }, []);

  const loadAds = async () => {
    try {
      const response = await getActiveAds();
      setAds(response.data || []);
    } catch (error) {
      console.error("Error loading ads:", error);
    }
  };

  const handleDismiss = async (adId) => {
    try {
      await dismissAd(adId);
      setAds(ads.filter((ad) => ad.id !== adId));
      if (currentIndex >= ads.length - 1) setCurrentIndex(0);
    } catch (error) {
      console.error("Error dismissing ad:", error);
    }
  };

  const handleClick = async (ad) => {
    try {
      await clickAd(ad.id);
      if (ad.link_url) window.open(ad.link_url, "_blank");
    } catch (error) {
      console.error("Error tracking click:", error);
    }
  };

  if (!ads || ads.length === 0) return null;

  const ad = ads[currentIndex];
  const typeColors = { announcement: "info", promo: "warning", external: "success" };
  const typeLabels = { announcement: "📢 Announcement", promo: "🎯 Promotion", external: "📣 Sponsored" };

  return (
    <Card
      sx={{
        background: (theme) => `linear-gradient(135deg, ${theme.palette[typeColors[ad.type] || "info"].main} 0%, ${theme.palette[typeColors[ad.type] || "info"].dark || theme.palette[typeColors[ad.type] || "info"].main} 100%)`,
        color: "white",
        mb: 3,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {ad.image_url && (
        <MDBox
          component="img"
          src={ad.image_url}
          alt={ad.title}
          // sx={{
          //   position: "absolute",
          //   right: 0,
          //   top: 0,
          //   height: "100%",
          //   width: "35%",
          //   objectFit: "cover",
          //   opacity: 1,
          // }}
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            height: "100%",
            width: "35%",
            objectFit: "cover",
            maskImage: "linear-gradient(to left, black 60%, transparent 100%)",
          }}
        />
      )}
      <MDBox p={3} position="relative" zIndex={1}>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start">
          <MDBox>
            <MDTypography variant="caption" color="white" opacity={0.8} fontWeight="medium">
              {typeLabels[ad.type] || "Notice"}
            </MDTypography>
            <MDTypography variant="h5" color="white" fontWeight="bold" mt={0.5}>
              {ad.title}
            </MDTypography>
            {ad.content && (
              <MDTypography variant="body2" color="white" opacity={0.9} mt={1} sx={{ maxWidth: "60%" }}>
                {ad.content}
              </MDTypography>
            )}
            {ad.link_url && (
              <MDButton
                variant="contained"
                color="white"
                size="small"
                onClick={() => handleClick(ad)}
                sx={{ mt: 2, color: typeColors[ad.type] || "info" }}
              >
                {ad.link_text || "Learn More"} <Icon sx={{ ml: 0.5 }}>arrow_forward</Icon>
              </MDButton>
            )}
          </MDBox>
          <MDBox display="flex" flexDirection="column" alignItems="center">
            {ad.dismissible && (
              <IconButton size="small" onClick={() => handleDismiss(ad.id)} sx={{ color: "white", opacity: 0.7, "&:hover": { opacity: 1 } }}>
                <Icon>close</Icon>
              </IconButton>
            )}
            {ads.length > 1 && (
              <MDBox display="flex" alignItems="center" sx={{
                position: "absolute",
                bottom: 12,
                right: 16,
                background: "rgba(0,0,0,0.2)",
                borderRadius: "20px",
                px: 1
              }}>
                <IconButton size="small" onClick={() => setCurrentIndex((i) => (i > 0 ? i - 1 : ads.length - 1))} sx={{ color: "white" }}>
                  <Icon>chevron_left</Icon>
                </IconButton>
                <MDTypography variant="caption" color="white" mx={1}>
                  {currentIndex + 1} / {ads.length}
                </MDTypography>
                <IconButton size="small" onClick={() => setCurrentIndex((i) => (i < ads.length - 1 ? i + 1 : 0))} sx={{ color: "white" }}>
                  <Icon>chevron_right</Icon>
                </IconButton>
              </MDBox>
            )}
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default AdBanner;

